import { Paper } from "@mui/material";
import React from "react";
import { Outlet } from "react-router-dom";

import Container from "../../view/Container";
import ContainerTitle from "../../view/ContainerTitle";

const AdminContainer = () => (
  <Container>
    <ContainerTitle />
    <Paper>
      <React.Suspense fallback={null}>
        <Outlet />
      </React.Suspense>
    </Paper>
  </Container>
);

export default AdminContainer;
